import { render, staticRenderFns } from "./scoreEntryStudent.vue?vue&type=template&id=0ad9f942&scoped=true"
import script from "./scoreEntryStudent.vue?vue&type=script&lang=js"
export * from "./scoreEntryStudent.vue?vue&type=script&lang=js"
import style0 from "./scoreEntryStudent.vue?vue&type=style&index=0&id=0ad9f942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad9f942",
  null
  
)

export default component.exports